<script setup>
const { placeholder } = defineProps({
  placeholder: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['searchClick', 'input'])
const query = defineModel({ type: String })
const onInput = () => emit('input', query.value)
const onSearchClick = () => emit('searchClick')
</script>
<template>
  <div class="flex h-10 rounded-[20px] shadow-[0px_0px_13px_2px_rgba(218,218,218,0.5)] bg-white text-darkBlue">
    <input
      v-model="query"
      type="text"
      class="focus:outline-none py-2 pl-3 pr-1 rounded-[20px] w-full lg:w-[148px]"
      :placeholder="placeholder"
      @input="onInput"
      @keydown.enter="onSearchClick"
    >
    <button class="search-button pointer" @click="onSearchClick">
      <IconSearch class="size-6 mr-2" />
    </button>
  </div>
</template>